import { negociacaoIndividualWizardService } from './services';

export const buscarDefinicaoDoAgente = negociacaoIndividualWizardService.getAgentById;
